/* ==========================================================================
   Main Collection — oddit-section-main-collection
   Interactive behaviors: filter toggles, section rendering API, sort
   ========================================================================== */

(function () {
  "use strict";

  var SECTION_SEL = ".oddit-section-main-collection";
  var HEADER_SEL = ".oddit-section-collection-header";

  function init(root) {
    var section = root
      ? root.querySelector(SECTION_SEL)
      : document.querySelector(SECTION_SEL);
    if (!section) return;

    initFilterToggles(section);
    initFilterForm(section);
    initFilterBadges(section);
    initMobileFilterDrawer(section);
    initMobileFilterTrigger(section);
    initAddToCart(section);
    initPromoCardClick(section);
    initSortSelect(section);
  }

  /* ---- Reveal after section re-render ---- */

  function revealSection(section) {
    var GRID_SEL = ".oddit-section-main-collection__grid";
    var reveals = section.querySelectorAll(".oddit-reveal");

    for (var i = 0; i < reveals.length; i++) {
      var el = reveals[i];
      if (el.closest(GRID_SEL)) {
        // Product cards: remove the reveal class entirely so they render visible immediately
        el.classList.remove("oddit-reveal");
        continue;
      }
      // Everything else (toolbar, sidebar, filter groups): skip animation
      el.classList.remove("oddit-reveal");
      el.classList.add("is-visible");
    }
  }

  /* ---- Section Rendering API ---- */

  function getSectionIdFromSelector(selector) {
    var sectionEl = document.querySelector(selector);
    if (!sectionEl) return null;
    var wrapper = sectionEl.closest(".shopify-section");
    if (!wrapper && sectionEl.id) return sectionEl.id;
    if (!wrapper) return null;
    return wrapper.id.replace("shopify-section-", "");
  }

  function getSectionId() {
    return getSectionIdFromSelector(SECTION_SEL);
  }

  function renderSection(url) {
    var sectionId = getSectionId();
    if (!sectionId) {
      window.location.href = url;
      return;
    }

    var headerSectionId = getSectionIdFromSelector(HEADER_SEL);
    var sectionsParam = sectionId + (headerSectionId ? "," + headerSectionId : "");
    var fetchUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "sections=" + sectionsParam;

    fetch(fetchUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) {
          window.location.href = url;
          return;
        }

        var temp = document.createElement("div");
        temp.innerHTML = html;

        var newSection = temp.querySelector(SECTION_SEL);
        var currentSection = document.querySelector(SECTION_SEL);
        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
          window.history.pushState({}, "", url);

          if (headerSectionId && data[headerSectionId]) {
            var headerTemp = document.createElement("div");
            headerTemp.innerHTML = data[headerSectionId];
            var QUICK_LINKS_SEL = ".oddit-section-collection-header__quick-links";
            var CONTAINER_SEL = ".oddit-section-collection-header__container";
            var newQuickLinks = headerTemp.querySelector(QUICK_LINKS_SEL);
            var currentContainer = document.querySelector(CONTAINER_SEL);
            if (currentContainer) {
              var currentQuickLinks = currentContainer.querySelector(QUICK_LINKS_SEL);
              if (!newQuickLinks && currentQuickLinks) {
                currentQuickLinks.remove();
              } else if (newQuickLinks && !currentQuickLinks) {
                var reveals = newQuickLinks.querySelectorAll(".oddit-reveal");
                for (var r = 0; r < reveals.length; r++) {
                  reveals[r].classList.remove("oddit-reveal");
                  reveals[r].classList.add("is-visible");
                }
                newQuickLinks.classList.remove("oddit-reveal");
                currentContainer.appendChild(newQuickLinks);
              }
            }
          }

          revealSection(currentSection);
          init();
        } else {
          window.location.href = url;
        }
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  function buildFilterUrl(form) {
    var formData = new FormData(form);
    var url = new URL(form.action || window.location.pathname, window.location.origin);

    // Clear existing filter params but keep non-filter params
    url.search = "";

    var entries = formData.entries();
    var entry = entries.next();
    while (!entry.done) {
      var key = entry.value[0];
      var val = entry.value[1];
      if (val !== "" && val !== undefined) {
        url.searchParams.append(key, val);
      }
      entry = entries.next();
    }

    return url.toString();
  }

  /* ---- Filter form submit (Section Rendering API) ---- */

  var countDebounceTimer = null;

  /* ---- Active filter badges ---- */

  function initFilterBadges(section) {
    var badges = section.querySelectorAll("[data-filter-remove]");
    if (!badges.length) return;

    var handlers = [];

    badges.forEach(function (badge) {
      var handler = function () {
        var filterKey = badge.getAttribute("data-filter-remove");
        var parts = filterKey.split(":");
        var paramName = parts[0];
        var paramValue = parts.slice(1).join(":");

        var url = new URL(window.location.href);
        var allValues = url.searchParams.getAll(paramName);
        url.searchParams.delete(paramName);

        for (var i = 0; i < allValues.length; i++) {
          if (allValues[i] !== paramValue) {
            url.searchParams.append(paramName, allValues[i]);
          }
        }

        renderSection(url.toString());
      };

      badge.addEventListener("click", handler);
      handlers.push({ el: badge, click: handler });
    });

    section._odditBadgeHandlers = handlers;
  }

  function initFilterForm(section) {
    var form = section.querySelector("[data-filter-form]");
    if (!form) return;

    var submitHandler = function (e) {
      e.preventDefault();
      var url = buildFilterUrl(form);
      renderSection(url);
    };

    form.addEventListener("submit", submitHandler);

    var changeHandler = function () {
      clearTimeout(countDebounceTimer);
      countDebounceTimer = setTimeout(function () {
        updateFilterCount(form, section);
      }, 300);
    };

    form.addEventListener("change", changeHandler);

    var clearBtn = section.querySelector("[data-filter-clear]");
    var clearHandler = null;
    if (clearBtn) {
      clearHandler = function () {
        var url = new URL(form.action || window.location.pathname, window.location.origin);
        var sortInput = form.querySelector("input[name='sort_by']");
        if (sortInput && sortInput.value) {
          url.searchParams.set("sort_by", sortInput.value);
        }
        renderSection(url.toString());
      };
      clearBtn.addEventListener("click", clearHandler);
    }

    section._odditFilterFormHandler = {
      el: form,
      submit: submitHandler,
      change: changeHandler,
      clearBtn: clearBtn,
      clear: clearHandler
    };
  }

  function updateFilterCount(form, section) {
    var sectionId = getSectionId();
    if (!sectionId) return;

    var btnText = section.querySelector("[data-filter-btn-text]");
    if (!btnText) return;

    var hasChecked = form.querySelector("input[type='checkbox']:checked") !== null;
    if (!hasChecked) {
      btnText.textContent = "SHOW RESULTS";
      return;
    }

    var url = buildFilterUrl(form);
    var fetchUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "sections=" + sectionId;

    fetch(fetchUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var temp = document.createElement("div");
        temp.innerHTML = html;

        var newProductCount = temp.querySelector(".oddit-section-main-collection__product-count");
        if (newProductCount) {
          var match = newProductCount.textContent.match(/of\s+(\d+)/);
          if (match) {
            btnText.textContent = "VIEW " + match[1] + " RESULTS";
          }
        }
      })
      .catch(function () {});
  }

  /* ---- Filter group expand / collapse ---- */

  function initFilterToggles(section) {
    var headingRows = section.querySelectorAll(
      ".oddit-section-main-collection__filter-heading-row"
    );

    var handlers = [];

    headingRows.forEach(function (row) {
      var group = row.closest(".oddit-section-main-collection__filter-group");
      if (!group) return;

      var content =
        group.querySelector(
          ".oddit-section-main-collection__filter-options-list"
        ) ||
        group.querySelector(
          ".oddit-section-main-collection__price-slider"
        );

      if (!content) return;

      row.setAttribute("role", "button");
      row.setAttribute("tabindex", "0");
      row.setAttribute("aria-expanded", "true");

      var clickHandler = function () {
        toggleFilter(row, content);
      };

      var keyHandler = function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleFilter(row, content);
        }
      };

      row.addEventListener("click", clickHandler);
      row.addEventListener("keydown", keyHandler);

      handlers.push({ el: row, click: clickHandler, keydown: keyHandler });
    });

    section._odditFilterHandlers = handlers;
  }

  function toggleFilter(row, content) {
    var expanded = row.getAttribute("aria-expanded") === "true";
    row.setAttribute("aria-expanded", String(!expanded));

    if (expanded) {
      content.style.maxHeight = content.scrollHeight + "px";
      content.offsetHeight; // eslint-disable-line no-unused-expressions
      content.style.maxHeight = "0";
      content.style.overflow = "hidden";
      content.style.transition = "max-height 0.25s ease";
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.overflow = "hidden";
      content.style.transition = "max-height 0.25s ease";

      var onEnd = function () {
        content.style.maxHeight = "";
        content.style.overflow = "";
        content.style.transition = "";
        content.removeEventListener("transitionend", onEnd);
      };
      content.addEventListener("transitionend", onEnd);
    }

    var chevron = row.querySelector(
      ".oddit-section-main-collection__filter-chevron"
    );
    if (chevron) {
      chevron.style.transform = expanded ? "rotate(90deg)" : "rotate(0deg)";
    }
  }

  /* ---- Add to cart → oddit cart drawer ---- */

  function initAddToCart(section) {
    var handler = function (e) {
      var btn = e.target.closest("[data-add-to-cart]");
      if (!btn || !window.OdditCartDrawer) return;

      var variantId = Number(btn.getAttribute("data-variant-id"));
      if (!variantId) return;

      var quantity = Number(btn.getAttribute("data-quantity")) || 1;
      var originalText = btn.textContent;

      btn.disabled = true;
      btn.classList.add("oddit-product-card__add-btn--loading");
      btn.textContent = "";

      window.OdditCartDrawer.addToCart(variantId, quantity)
        .then(function () {
          window.OdditCartDrawer.open();
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove("oddit-product-card__add-btn--loading");
          btn.textContent = originalText;
        });
    };

    section.addEventListener("click", handler);
    section._odditAddToCartHandler = handler;
  }

  /* ---- Mobile filter drawer ---- */

  function openDrawer(drawer) {
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var firstFocusable = drawer.querySelector("[data-filter-drawer-close], .oddit-section-main-collection__drawer-group-toggle");
    if (firstFocusable) {
      requestAnimationFrame(function () { firstFocusable.focus(); });
    }
  }

  function closeDrawer(drawer) {
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function initMobileFilterDrawer(section) {
    var drawer = section.querySelector("[data-filter-drawer]");
    if (!drawer) return;

    var closeBtn = drawer.querySelector("[data-filter-drawer-close]");
    var overlay = drawer.querySelector("[data-filter-drawer-overlay]");
    var toggles = drawer.querySelectorAll(".oddit-section-main-collection__drawer-group-toggle");
    var drawerForm = drawer.querySelector("[data-filter-drawer-form]");

    // Toggle filter groups open/closed
    var toggleHandlers = [];
    for (var i = 0; i < toggles.length; i++) {
      (function (btn) {
        var handler = function () {
          var isExpanded = btn.getAttribute("aria-expanded") === "true";
          var content = btn.nextElementSibling;
          if (!content) return;
          if (isExpanded) {
            btn.setAttribute("aria-expanded", "false");
            content.setAttribute("hidden", "");
          } else {
            btn.setAttribute("aria-expanded", "true");
            content.removeAttribute("hidden");
          }
        };
        btn.addEventListener("click", handler);
        toggleHandlers.push({ el: btn, click: handler });
      })(toggles[i]);
    }

    // Close drawer
    var closeHandler = function () { closeDrawer(drawer); };

    if (closeBtn) closeBtn.addEventListener("click", closeHandler);
    if (overlay) overlay.addEventListener("click", closeHandler);

    drawer.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer(drawer);
    });

    // Drawer form submit via Section Rendering API
    if (drawerForm) {
      drawerForm.addEventListener("submit", function (e) {
        e.preventDefault();
        closeDrawer(drawer);
        var url = buildFilterUrl(drawerForm);
        renderSection(url);
      });

      drawerForm.addEventListener("change", function () {
        clearTimeout(countDebounceTimer);
        countDebounceTimer = setTimeout(function () {
          updateDrawerFilterCount(drawerForm, section);
        }, 300);
      });
    }

    section._odditDrawerHandlers = {
      drawer: drawer,
      close: closeHandler,
      closeBtn: closeBtn,
      overlay: overlay,
      toggles: toggleHandlers,
      form: drawerForm
    };
  }

  function updateDrawerFilterCount(form, section) {
    var sectionId = getSectionId();
    if (!sectionId) return;

    var btnText = section.querySelector("[data-filter-drawer-btn-text]");
    if (!btnText) return;

    var hasChecked = form.querySelector("input[type='checkbox']:checked") !== null;
    if (!hasChecked) {
      btnText.textContent = "VIEW RESULTS";
      return;
    }

    var url = buildFilterUrl(form);
    var fetchUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "sections=" + sectionId;

    fetch(fetchUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var temp = document.createElement("div");
        temp.innerHTML = html;

        var newProductCount = temp.querySelector(".oddit-section-main-collection__product-count");
        if (newProductCount) {
          var match = newProductCount.textContent.match(/of\s+(\d+)/);
          if (match) {
            btnText.textContent = "VIEW " + match[1] + " RESULTS";
          }
        }
      })
      .catch(function () {});
  }

  function initMobileFilterTrigger(section) {
    var trigger = section.querySelector("[data-filter-mobile-trigger]");
    if (!trigger) return;

    var drawer = section.querySelector("[data-filter-drawer]");

    var handler = function () {
      if (drawer) openDrawer(drawer);
    };

    trigger.addEventListener("click", handler);
    section._odditMobileFilterHandler = { el: trigger, click: handler };
  }

  /* ---- Sort select (Section Rendering API) ---- */

  function initSortSelect(section) {
    var select = section.querySelector("[data-sort-select]");
    if (!select) return;

    var valueDisplay = section.querySelector("[data-sort-value]");

    var handler = function () {
      if (valueDisplay) {
        valueDisplay.textContent = select.options[select.selectedIndex].text;
      }
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      renderSection(url.toString());
    };

    select.addEventListener("change", handler);
    section._odditSortHandler = { el: select, change: handler };
  }

  /* ---- Promo card: whole card clickable ---- */

  function initPromoCardClick(section) {
    var promoCards = section.querySelectorAll(
      ".oddit-section-main-collection__promo-card"
    );

    var handlers = [];

    promoCards.forEach(function (card) {
      var link = card.querySelector(
        ".oddit-section-main-collection__promo-link"
      );
      if (!link) return;

      card.style.cursor = "pointer";

      var clickHandler = function (e) {
        if (e.target.closest("a")) return;
        link.click();
      };

      card.addEventListener("click", clickHandler);
      handlers.push({ el: card, click: clickHandler });
    });

    section._odditPromoHandlers = handlers;
  }

  /* ---- Handle browser back/forward ---- */

  window.addEventListener("popstate", function () {
    renderSection(window.location.href);
  });

  /* ---- Theme Editor Events ---- */

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelector(SECTION_SEL)) {
      init(e.target);
    }
  });

  document.addEventListener("shopify:section:unload", function (e) {
    var section = e.target.querySelector(SECTION_SEL);
    if (section) {
      destroy(section);
    }
  });

  /* ---- Cleanup ---- */

  function destroy(section) {
    if (!section) return;

    if (section._odditFilterHandlers) {
      section._odditFilterHandlers.forEach(function (h) {
        h.el.removeEventListener("click", h.click);
        h.el.removeEventListener("keydown", h.keydown);
      });
      section._odditFilterHandlers = null;
    }

    if (section._odditBadgeHandlers) {
      section._odditBadgeHandlers.forEach(function (h) {
        h.el.removeEventListener("click", h.click);
      });
      section._odditBadgeHandlers = null;
    }

    if (section._odditFilterFormHandler) {
      section._odditFilterFormHandler.el.removeEventListener("submit", section._odditFilterFormHandler.submit);
      section._odditFilterFormHandler.el.removeEventListener("change", section._odditFilterFormHandler.change);
      if (section._odditFilterFormHandler.clearBtn && section._odditFilterFormHandler.clear) {
        section._odditFilterFormHandler.clearBtn.removeEventListener("click", section._odditFilterFormHandler.clear);
      }
      section._odditFilterFormHandler = null;
    }

    if (section._odditPromoHandlers) {
      section._odditPromoHandlers.forEach(function (h) {
        h.el.removeEventListener("click", h.click);
      });
      section._odditPromoHandlers = null;
    }

    if (section._odditAddToCartHandler) {
      section.removeEventListener("click", section._odditAddToCartHandler);
      section._odditAddToCartHandler = null;
    }

    if (section._odditDrawerHandlers) {
      var dh = section._odditDrawerHandlers;
      if (dh.closeBtn) dh.closeBtn.removeEventListener("click", dh.close);
      if (dh.overlay) dh.overlay.removeEventListener("click", dh.close);
      if (dh.toggles) {
        dh.toggles.forEach(function (h) { h.el.removeEventListener("click", h.click); });
      }
      section._odditDrawerHandlers = null;
    }

    if (section._odditMobileFilterHandler) {
      section._odditMobileFilterHandler.el.removeEventListener("click", section._odditMobileFilterHandler.click);
      section._odditMobileFilterHandler = null;
    }

    if (section._odditSortHandler) {
      section._odditSortHandler.el.removeEventListener("change", section._odditSortHandler.change);
      section._odditSortHandler = null;
    }
  }

  /* ---- Boot ---- */

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }
})();
